import React from "react";
import InformationData from "./InformationData";
import "./InformationStyle.css";
import RS from "../../assets/images/RS.jpg";
import GG from "../../assets/images/GG.jpg";

const Information = (props) => {
  const infoClassName = `info-section ${props.isScrolled ? "scrolled" : ""}`;
  return (
    <section className={infoClassName}>
      <div className="information">
        <h1>Hi there!</h1>
        <p>
          I'm a junior software developer and recent graduate from Niagara
          College. With experience in Java, C#, Python, web development,
          database management, and software testing. I'm eager to take on
          challenging projects and collaborate with experienced developers. I'm
          dedicated, hard-working, and ready to contribute to projects that have
          a real-world impact.
          <br /> <br />
          Let's work together to create something amazing!
        </p>
        <br />

        <InformationData
          heading="Recommendations"
          text="We had the opportunity to work together during our time in NC developing applications for 
        SoilOptix and I can only say he is a remarkable, enthusiast and proactive colaborator who always 
        managed to find solutions to the most complex problems and deliver high quality solutions. 
        Pleasure to be his partner and work in the same team! - Gustavo Galindo"
          text2="Luis is a very committed and proactive person. He is always on top of all tasks and always thinking ahead. 
        Not only has this represented big savings for the company, but the changes were an upgrade to the services we were getting. 
        He has very good communication skills and has the ability to create multiple reports to show burn rates, inventory and sales. 
        It has been a real pleasure to work with him. Always hire someone smarter than you! - Ricardo Sousa"
          reviewLink="Linkedin | Luis Marquez"
          url="https://www.linkedin.com/in/luis-marquez-49556333/"
          img1={GG}
          img2={RS}
        />
      </div>
    </section>
  );
};

export default Information;
